export const EVENT_PLAYER_CHAPTER_CHANGE = 'vumedi:event:player:chapter-change';
export const EVENT_CLIENT_DISCLOSURE_RESOLVED = 'vumedi:event:client-disclosure:resolved';
